
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/makers",
      function () {
        return require("private-next-pages/shop/makers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/makers"])
      });
    }
  